<template>
  <div>
    <v-server-table
      :columns="columns"
      :options="tableOptions"
      @filter="onFilterUpdate"
      id="activeUsersTable"
      ref="activeUsersTable"
      name="activeUsersTable"
    >

    <span slot="date" slot-scope="{row}">
      <span v-if="row.created_at">
        {{ row.created_at | localTime('YYYY-MM-DD') }}
      </span>
    </span>

      <span slot="started_at" slot-scope="{row}">
      <span v-if="row.created_at">
        {{ row.created_at | localTime('HH:mm') }}
      </span>
    </span>

      <span slot="nickname" slot-scope="{row}">
      {{row.nickname ? row.nickname : "N/A"}}
    </span>

      <span slot="avg_consultation_time_minutes" slot-scope="{row}">
      <span v-if="row.avg_consultation_time_minutes">
        {{ getRelativeTimeString(row.avg_consultation_time_minutes, 'minutes') }}
      </span>
        <span v-else>
          N/A
        </span>
    </span>

      <span slot="suspended_activity" slot-scope="{row}">
      <va-popover :message="$t('evocall.active_users.in_break')" placement="left" v-if="row.suspended_activity">
        <i class="fa fa-check"></i>
      </va-popover>
    </span>

    </v-server-table>
  </div>
</template>

<script>
import TableQueryMixin from '@/mixins/TableQueryMixin'
import Multiselect from 'vue-multiselect'
import RangeDatePicker from '@/components/common/RangeDatePicker'
import RelativeTimeMixin from '@/mixins/RelativeTimeMixin'
import EventBus from "@/utils/EventBus";

export default {
  components: {
    Multiselect,
    RangeDatePicker
  },
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
  },
  mixins: [
    TableQueryMixin,
    RelativeTimeMixin
  ],
  data() {
    return {
      columns: [
        'date',
        'started_at',
        'name',
        'nickname',
        'requests_made',
        'avg_consultation_time_minutes',
        'suspended_activity'
      ],
      queryUrl: `${this.$store.state.virtual_waiting_room_server}/v1/online-users`,
      tableOptions: {
        columnsDropdown: false,
        saveState: true,
        filterable: true,
        pagination: {
          show: false,
          chunk: 10,
          nav: 'scroll',
          edge: true
        },
        sortable: ['created_at', 'suspended_activity'],
        customFilters: [],
        headings: {
          'date': this.$t('evocall.active_users.date'),
          'started_at': this.$t('evocall.active_users.started_at'),
          'name': this.$t('evocall.active_users.name'),
          'nickname': this.$t('evocall.active_users.nickname'),
          'requests_made': this.$t('evocall.active_users.count_daily_requests'),
          'avg_consultation_time_minutes': this.$t('evocall.active_users.avg_daily_request_time'),
          'suspended_activity': this.$t('evocall.active_users.in_break')
        },
        columnsClasses: {
          results: 'results',
          actions: 'actions',
          requests_made: 'count_daily_requests',
          avg_consultation_time_minutes: 'average_daily_request_time',
          suspended_activity: 'in_break'
        },
        orderBy: {
          column: 'created_at',
          ascending: 1
        }
      }
    }
  },

  methods: {
    reloadTable: function () {
      this.getTableReference().refresh()
    },
    getTableReference: function () {
      return this.$refs.activeUsersTable
    }
  },
  computed: {},
  watch: {},
  created() {
    EventBus.$on('online-users-updated', () => {
      this.reloadTable()
    })
  }

}
</script>
<style lang="scss">

#activeUsersTable {
  td {
    &.count_daily_requests, &.average_daily_request_time, &.in_break {
      text-align: center;
    }
  }
}
</style>
